<div class="mx-auto max-w-6xl px-4 py-6 sm:px-5 sm:py-8">
    <header class="mb-6 space-y-0.5">
        <h1 class="text-4xl font-bold leading-tight text-slate-900">Prodotti</h1>
        <p class="text-sm text-slate-500">Sfoglia il catalogo e apri un articolo per varianti e acquisto.</p>
    </header>

    <div *ngIf="products && products.length > 0" class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
        <article *ngFor="let product of products"
            class="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-sm ring-1 ring-slate-900/5 transition hover:-translate-y-0.5 hover:shadow-md hover:ring-slate-900/10"
            (click)="showProductModal(product)">
            <div class="relative aspect-square overflow-hidden bg-slate-100">
                <img class="h-full w-full object-cover transition duration-300 group-hover:scale-[1.02]"
                    [src]="product.coverImage ? product.coverImage : product.images ? product.images[0].imageUrl : 'assets/images/no-image.png'"
                    [attr.alt]="product.name" />
            </div>
            <div class="flex flex-1 flex-col p-4">
                <h2 class="line-clamp-2 text-sm font-semibold leading-snug text-slate-900">{{ product.name }}</h2>
                <div *ngIf="product.shortDescription && product.shortDescription.length > 0"
                    class="mt-2 line-clamp-2 text-xs leading-relaxed text-slate-500 [&_a]:text-[var(--primary-color)]"
                    [innerHTML]="product.shortDescription">
                </div>
                <div class="mt-auto flex flex-wrap items-baseline gap-x-2 gap-y-1 pt-3">
                    <ng-container *ngIf="product.reducedPrice !== product.fullPrice; else cardFullPrice">
                        <del class="text-sm tabular-nums text-slate-400">{{ product.fullPrice | currency:'EUR':true }}</del>
                        <span class="text-lg font-semibold tabular-nums text-[var(--primary-color)]">{{ product.reducedPrice | currency:'EUR':true }}</span>
                    </ng-container>
                    <ng-template #cardFullPrice>
                        <span class="text-lg font-semibold tabular-nums text-slate-900">{{ product.fullPrice | currency:'EUR':true }}</span>
                    </ng-template>
                </div>
            </div>
        </article>
    </div>

    <div *ngIf="products && products.length === 0"
        class="rounded-2xl border border-dashed border-slate-200 bg-slate-50/50 px-6 py-12 text-center sm:py-16">
        <p class="text-sm font-medium text-slate-900">Nessun prodotto disponibile.</p>
        <p class="mt-2 text-sm text-slate-500">Torna più tardi o contatta la società.</p>
    </div>
</div>

<ngx-smart-modal #viewProductModal identifier="viewProductModal" [customClass]="'shop-product-modal'"
    (onClose)="handleOnCloseModal('viewProductModal')" [closable]="true" (onAnyCloseEvent)="clearModalData()">
    <ng-container *ngIf="viewProductModal.hasData()">
        <div
            class="max-h-[min(92vh,920px)] overflow-y-auto overscroll-contain rounded-2xl border border-slate-200/90 bg-white shadow-2xl ring-1 ring-slate-900/10">
            <!-- Header (leave space for ngx close button) -->
            <header class="sticky top-0 z-[1] border-b border-slate-100 bg-gradient-to-br from-slate-50/95 to-white px-5 py-4 pr-14 backdrop-blur-sm sm:px-6 sm:pr-16">
                <p class="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Dettaglio prodotto</p>
                <h2 class="mt-1 text-lg font-semibold leading-snug text-slate-900 sm:text-xl">
                    {{ viewProductModal.getData().name }}
                </h2>
            </header>

            <div class="flex flex-col gap-6 p-5 sm:p-6 lg:flex-row lg:items-start lg:gap-8">
                    <!-- Gallery -->
                    <div class="w-full shrink-0 lg:max-w-[min(100%,22rem)] lg:flex-1">
                        <div class="rounded-xl bg-slate-100/90 p-3 ring-1 ring-inset ring-slate-200/60 sm:p-4">
                            <div class="flex items-center justify-center gap-2 sm:gap-3">
                                <button type="button" (click)="prevSlide(); $event.stopPropagation()"
                                    class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-slate-200/90 bg-white text-slate-700 shadow-sm transition hover:bg-white hover:shadow focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]/25"
                                    *ngIf="images.length > 1" aria-label="Immagine precedente">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                        viewBox="0 0 16 16" aria-hidden="true">
                                        <path
                                            d="M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z" />
                                    </svg>
                                </button>
                                <div class="relative min-h-[200px] w-full max-w-sm flex-1 sm:min-h-[240px]"
                                    (click)="zoom(currentImage())">
                                    <img *ngIf="images.length" [src]="currentImage()"
                                        [attr.alt]="viewProductModal.getData().name"
                                        class="mx-auto max-h-[min(42vh,280px)] w-full cursor-zoom-in rounded-lg object-contain" />
                                    <span
                                        class="pointer-events-none absolute bottom-2 right-2 inline-flex items-center gap-1 rounded-md bg-white/95 px-2 py-1 text-[11px] font-medium text-slate-600 shadow-sm ring-1 ring-slate-200/80"
                                        *ngIf="images.length">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                                            class="shrink-0" viewBox="0 0 16 16" aria-hidden="true">
                                            <path fill-rule="evenodd"
                                                d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z" />
                                            <path
                                                d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z" />
                                            <path fill-rule="evenodd"
                                                d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z" />
                                        </svg>
                                        Zoom
                                    </span>
                                </div>
                                <button type="button" (click)="nextSlide(); $event.stopPropagation()"
                                    class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-slate-200/90 bg-white text-slate-700 shadow-sm transition hover:bg-white hover:shadow focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]/25"
                                    *ngIf="images.length > 1" aria-label="Immagine successiva">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                        viewBox="0 0 16 16" aria-hidden="true">
                                        <path
                                            d="M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z" />
                                    </svg>
                                </button>
                            </div>
                            <div *ngIf="images.length > 1" class="mt-3 flex flex-wrap items-center justify-center gap-2">
                                <button *ngFor="let img of images; let i = index" type="button"
                                    (click)="goToSlide(i); $event.stopPropagation()"
                                    class="h-2 w-2 rounded-full transition focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]/40"
                                    [class.bg-[var(--primary-color)]]="i === currentIndex"
                                    [class.bg-slate-300]="i !== currentIndex"
                                    [attr.aria-label]="'Immagine ' + (i + 1)"
                                    [attr.aria-current]="i === currentIndex"></button>
                                <span class="w-full text-center text-[11px] text-slate-400 sm:w-auto sm:pl-2">
                                    {{ currentIndex + 1 }} / {{ images.length }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Details -->
                    <div class="min-w-0 flex-1 lg:max-w-xl">
                        <div *ngIf="viewProductModal.getData().description; else noDesc"
                            class="max-w-none text-sm leading-relaxed text-slate-600 [&_p]:mb-3 [&_p:last-child]:mb-0 [&_a]:text-[var(--primary-color)] [&_a]:underline"
                            [innerHtml]="getClearDescription(viewProductModal.getData().description)">
                        </div>
                        <ng-template #noDesc>
                            <p class="text-sm italic text-slate-400">Nessuna descrizione disponibile.</p>
                        </ng-template>

                        <div class="mt-5 rounded-xl border border-slate-100 bg-slate-50/60 p-4">
                            <p class="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Prezzo</p>
                            <p class="mt-1 text-2xl font-semibold tabular-nums text-slate-900">
                                <ng-container
                                    *ngIf="viewProductModal.getData().reducedPrice !== viewProductModal.getData().fullPrice; else modalFullPrice">
                                    <span class="text-base font-normal text-slate-400 line-through">{{
                                        viewProductModal.getData().fullPrice | currency:'EUR':true }}</span>
                                    <span class="ml-2 text-[var(--primary-color)]">{{
                                        viewProductModal.getData().reducedPrice | currency:'EUR':true }}</span>
                                </ng-container>
                                <ng-template #modalFullPrice>
                                    <span>{{ viewProductModal.getData().fullPrice | currency:'EUR':true }}</span>
                                </ng-template>
                            </p>
                        </div>

                        <div class="mt-6 space-y-4">
                            <div>
                                <label for="size"
                                    class="mb-1.5 block text-xs font-medium text-slate-600">Variante <span
                                        class="text-red-500">*</span></label>
                                <select id="size" name="size" [(ngModel)]="selectedBarcode"
                                    class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-900 shadow-sm focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30">
                                    <option value="">Seleziona...</option>
                                    <ng-container *ngFor="let barcode of viewProductModal.getData().barcode">
                                        <option [value]="barcode.id" *ngIf="barcode.quantityStock > 0">
                                            {{ barcode.size.name }} - {{ barcode.color.name }} ({{ barcode.quantityStock }}
                                            disponibili)
                                        </option>
                                    </ng-container>
                                </select>
                            </div>
                            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                                <div>
                                    <label for="quantity"
                                        class="mb-1.5 block text-xs font-medium text-slate-600">Quantità <span
                                            class="text-red-500">*</span></label>
                                    <input type="number" id="quantity" [(ngModel)]="selectedQuantity" placeholder="1"
                                        min="1"
                                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-900 shadow-sm focus:border-[var(--primary-color)] focus:outline-none focus:ring-1 focus:ring-[var(--primary-color)]/30" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            <footer
                class="sticky bottom-0 z-[1] border-t border-slate-100 bg-slate-50/95 px-5 py-4 backdrop-blur-sm sm:flex sm:justify-end sm:px-6">
                <button type="button" (click)="addToCart()" [disabled]="!addToCartValidation()"
                    class="inline-flex w-full items-center justify-center gap-2 rounded-lg px-6 py-3 text-sm font-semibold text-white shadow-md transition hover:opacity-[0.97] focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto sm:min-w-[14rem]"
                    style="background-color: var(--primary-color)">
                    Aggiungi al carrello
                    <i class="bi bi-cart-fill text-base" aria-hidden="true"></i>
                </button>
            </footer>
        </div>
    </ng-container>
</ngx-smart-modal>

<ngx-smart-modal #zoomImageModal identifier="zoomImageModal" [customClass]="'shop-zoom-modal'"
    (onAnyCloseEvent)="handleOnCloseModal('zoomImage')" [closable]="true">
    <ng-container *ngIf="viewProductModal.hasData()">
        <div class="rounded-2xl border border-slate-200/90 bg-slate-950/5 p-3 shadow-2xl ring-1 ring-slate-900/10 sm:p-4">
            <img [src]="zoomImageModal.getData()" id="imagepreview"
                class="mx-auto max-h-[min(88vh,920px)] w-auto max-w-full rounded-xl object-contain"
                [attr.alt]="viewProductModal.getData().name || ''" />
        </div>
    </ng-container>
</ngx-smart-modal>
